<template>
  <div>
    <el-card body-style="padding: 0">
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">公告管理</span>
      </div>
      <el-form ref="queryForm" :model="queryForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label="分类" prop="noticeType">
              <el-select v-model="queryForm.noticeType" clearable placeholder="请选择分类">
                <el-option
                    v-for="item in allNoticeTypes"
                    :key="item.id"
                    :label="item.noticeTypeName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="标题" prop="noticeTitle">
              <el-input v-model="queryForm.noticeTitle" placeholder="请输入标题"/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="平台站点" prop="plateform">
              <el-select v-model="queryForm.plateform" clearable placeholder="请选择站点">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="1">
            <el-form-item>
              <el-button type="primary" size="small"
                         @click="submitQueryForm()" icon="el-icon-search">
                查询
              </el-button>
              <el-button type="primary" size="small" plain
                         @click="resetQueryForm()" icon="el-icon-refresh">
                重置
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd('新增用户')">新增
      </el-button>
      <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}"
                @selection-change="handleSelectionChange">
        <el-table-column label="全选" width="50" type="selection"/>
        <el-table-column prop="plateform" label="平台"/>
        <el-table-column prop="noticeTitle" label="标题">
          <template slot-scope="scope">
            <span style="color: #409EFF;">{{scope.row.isTop?"[置顶]":""}}</span>
            <span style="color: red;margin-left: 1%;">{{scope.row.isShow?"[弹窗]":""}}</span>
            <span style="color: red;margin-left: 1%;">{{scope.row.isNew?"[New]":""}}</span>
            <span style="color: red;margin-left: 1%;">{{scope.row.isNeed?"[必看]":""}}</span>
            <span style="margin-left: 1%;">{{scope.row.noticeTitle}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noticeString" label="分类"/>
        <el-table-column prop="stationStr" label="站点"/>
        <el-table-column prop="createTime" label="添加时间"/>
        <el-table-column prop="remarks" label="备注"/>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" plain
                       @click="handleEditNotice(scope.$index, scope.row,'修改字典项')">
              编辑
            </el-button>
            <el-button size="mini" type="success" plain
                       @click="handleDelete(scope.$index, scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {deleteNotice, getAllNotice, getAllNoticeType} from "../../api/b2cbusiness/b2c_admin";

export default {
  name: "NotificationManagelist",
  mixins: [MixinCUD],
  data() {
    return {
      tableData: [],
      allNoticeTypes:[],
      queryFormRefName:"queryForm",
      queryForm: {},
      options:[
        {
          id:0,
          value:"主站点",
        },
      ],
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.getData();
    getAllNoticeType({pageNum: 1,pageSize: 20}).then(res=>{
      console.log(res.data)
      if (res.success){
        this.allNoticeTypes = res.data.records;
      }
    });
  },
  methods: {
    handleAdd() {
      this.$router.push({path: '/home/noticeedit'});
    },
    handleEditNotice(index, row, title){
      this.$router.push({path: '/home/noticeedit', query:{noticData:row}});
    },
    getData(){
      getAllNotice(this.queryForm, this.pagination).then(res=>{
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    deleteData(dialogForm){
      deleteNotice(dialogForm).then(res=>{
        if (res.success){
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(31, 158, 254);
  color: rgb(255, 255, 255);
}
</style>
